// src/components/common/SearchBar.jsx
import React, { useState, useCallback, useRef } from 'react';
import SearchBox from './SearchBox';
import { USER_STATE } from '../../utils/common';
import userService from '../../services/userService';

export default function UserSearchBox({
  value,                  // keyword
  userState,              // userState
  onChange,               // setKeyword
  searchKind,               // searchKind
  onSelect,               // setSearchKind
  onSearch,               // handleSearch
  onReset,                // handleReset
  onSuggestSelect,         // 추천 클릭 시
  totalCount,               // totalCount
  showTotalCount=true,           // totalCount 표시 여부
  onExcelDownload,          // 엑셀 다운로드
  customFetchSuggestions,   // 커스텀 검색 API 함수 (선택적)
}) {
    const options = [
        { value: '0', label: '전체' },
        { value: '1', label: '회원명' },
        { value: '2', label: '아이디' },
        { value: '3', label: '이메일' },
    ];
    
    const [suggestions, setSuggestions] = useState([]);
    const debounceTimer = useRef(null);

    const getTextType = (item) => {
        //전체 or 이름으로 검색시
        if(searchKind === '0' || searchKind === '1'){return item.name;}
        //id로 검색시
        if(searchKind === '2'){return item.id;}
        //email로 검색시
        if(searchKind === '3'){return item.email;}
    }
    
    const fetchSuggestions = useCallback(async (kw) => {
        if (!kw) return setSuggestions([]);
        
        // 검색어 길이 제한 및 위험한 문자 차단
        if (kw.length > 50 || /[<>'"&]/.test(kw)) {
            setSuggestions([]);
            return;
        }
        
        // 커스텀 검색 함수가 제공되면 사용
        if (customFetchSuggestions) {
            try {
                const results = await customFetchSuggestions(kw, searchKind);
                setSuggestions(results.map(item => getTextType(item)));
            } catch (error) {
                console.error('Custom fetch suggestions error:', error);
                setSuggestions([]);
            }
            return;
        }
        
        // 새로운 userService API 사용
        try {
            const response = await userService.getSearchSuggest(
                Number(searchKind),
                kw,
                userState || USER_STATE.NORMAL
            );
            
            if (response.success) {
                setSuggestions(response.data.map(item => getTextType(item)));
            } else {
                setSuggestions([]);
            }
        } catch (error) {
            console.error('fetchSuggestions error:', error);
            setSuggestions([]);
        }
    }, [searchKind, userState, customFetchSuggestions]);

    // 디바운싱된 검색 제안 함수
    const debouncedFetchSuggestions = useCallback((kw) => {
        // 기존 타이머 클리어
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        
        // 새 타이머 설정 (300ms 지연)
        debounceTimer.current = setTimeout(() => {
            fetchSuggestions(kw);
        }, 300);
    }, [fetchSuggestions]);

    return (
      <div className="search_area">
        <div className="total_info add">
          {showTotalCount && (<span>총 가입 인원 <i style={{ color: '#26aea2', marginLeft: '5px' }}>{totalCount}</i>명</span>)}
        </div>
        <SearchBox
            value={value}
            onChange={(newValue) => {
              onChange(newValue); // Update keyword in AccountListPage (setKeyword)
              debouncedFetchSuggestions(newValue); // Debounced suggestions fetch
            }}
            options={options}
            selected={searchKind}
            onSelect={(newKind) => {
              onSelect(newKind); // Update search kind state
              fetchSuggestions(value); // Refresh suggestions for current keyword
            }}
            onSearch={() => {
              onSearch(); // Perform actual search (handleSearch in AccountListPage)
              setSuggestions([]); // Clear suggestions after search is committed
            }}
            onReset={onReset}
            suggestions={suggestions}
            onSuggestSelect={(selectedValue) => {
              onSuggestSelect(selectedValue); // Perform search with selected value
              setSuggestions([]); // Clear suggestions after selection
            }}
            onExcelDownload={onExcelDownload?onExcelDownload:null}
          />
      </div>
    );
}